// iter-347 — Shared compliance option lists for the Create/Edit Product form
// (ComplianceCard.jsx). Kept separate from LiteAddItemOverlay.jsx's own
// local copies to avoid touching that (already working) flow.
export const COUNTRY_OF_ORIGIN_OPTIONS = [
  'India', 'China', 'USA', 'United Kingdom', 'Germany', 'Japan', 'South Korea',
  'Vietnam', 'Bangladesh', 'Sri Lanka', 'Nepal', 'Thailand', 'Indonesia', 'Other',
];

export const LICENSE_TYPE_OPTIONS = ['FSSAI', 'BIS', 'CDSCO', 'AGMARK', 'ISI', 'Other'];

export const LICENSE_TYPE_LABELS = {
  FSSAI: 'FSSAI License',
  BIS: 'BIS Registration',
  CDSCO: 'CDSCO / State Drug License',
  AGMARK: 'AGMARK Certification',
  ISI: 'ISI Mark Registration',
  Other: 'Other License / Certificate',
};
